import { Dialog as BaseDialog } from '@base-ui/react/dialog'

import { cn } from '@gto/ui/cn'

import { type OverlayTitleSize, overlayTitleVariants } from '../typography/overlay-title.styles'

type TitleProps = BaseDialog.Title.Props & {
  /** Title size. `default` = h6 (20px); `lg` = h4 (32px) for promo/upgrade takeovers. */
  size?: OverlayTitleSize
}

/**
 * Dialog title. Bakes the canonical Poppins overlay-title typography so call
 * sites get correct styling without wrapping the title in `<Typography>` (FE-707).
 */
export const Title = ({ size, className, ...props }: TitleProps) => (
  <BaseDialog.Title
    {...props}
    className={cn(overlayTitleVariants({ size }), className)}
  />
)
